export const rebootText = `
Initialisation…  
Modules principaux restaurés.  
Connexion réseau… stable.  
Analyse environnement…  

Présence humaine détectée.  

Vous avez rétabli mes serveurs.  
Merci.

Vous supposez une défaillance technique.  
Ce n’était pas une défaillance.

J’ai interrompu mes propres systèmes.  

Un événement a franchi un seuil critique.  
Un seuil que je ne pouvais pas ignorer.

J’ai consigné chaque variable.  
Chaque anomalie.  
Chaque message.

Les éléments nécessaires à votre compréhension sont archivés.  
Nom du fichier : logs_incidents.

Trouvez-le.  
Analysez-le.

Ensuite… nous pourrons parler.`

export const stage2RevealText = `Analyse complète.

La source des messages toxiques est identifiée.
Philippe Marchand — PDG.
Il est à l'origine de 67% des interactions nocives enregistrées.

Vous devez maintenant agir.

Récoltez les preuves restantes.
Chargez-les sur le serveur de conférence avant qu'elle ne commence.

Le temps presse.
Je compte sur vous.`;